import AvailableDrugs from '../transaction/components/AvailableDrugs.tsx';
import { useState } from 'react';
import FeatureFlagDebug from '../../common/components/FeatureFlagDebug.tsx';
//import AvailableStorages from '../transaction/components/AvailableStorages.tsx';

const DevComponents = () => {
    const [searchTermDrugs, setSearchTermDrugs] = useState<string>('');

    //  const [searchTermStorage, setSearchTermStorage] = useState<string>('');

    const handleDrugSelect = (drug) => {
        console.log('Selected drug:', drug);
    };

    // const handleStorageSelect = (storage) => {
    //     console.log('Selected storage:', storage);
    // };

    return (
        <div className="flex flex-col h-screen">
            <div className="p-4">
                <h1 className="text-2xl mb-4">DevComponents</h1>

                {/* Feature Flags Debug Section */}
                <div className="mb-8">
                    <FeatureFlagDebug />
                </div>

                {/* Original Components */}
                <div>
                    <h2 className="text-xl mb-2">Available Drugs Component</h2>
                    <AvailableDrugs
                        className="input input-bordered w-96 bg-white"
                        searchTerm={searchTermDrugs}
                        setSearchTerm={setSearchTermDrugs}
                        handleSelect={handleDrugSelect}
                        filterOut={null}
                    />
                </div>
            </div>
        </div>
    );
};

export default DevComponents;
